import type { TFunction } from '../../types/types';
import type { SubscriptionDiscount } from '../mappers/serviceMapper/utils/payment.mapper';

export const getSubscriptionDiscountDuration = (
  { subscriptionCycles }: SubscriptionDiscount,
  totalPayments: number,
  t: TFunction,
): string =>
  subscriptionCycles === undefined || subscriptionCycles >= totalPayments
    ? t('app.payment.summary.subscription.discount.all-payments')
    : t('app.payment.summary.subscription.discount.first-payments', {
        count: subscriptionCycles,
      });
